export const storiesData = [
  {
    id: "cad36de1950dc9fb8ab751fc",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2L5jgOwMoZrw62HmxIVIXZTXKI6Pkg7QPCQ&usqp=CAU",
    userName: "Ransom74",
  },
  {
    id: "f5ebb8eb0f2dd55d1964b04f",
    userAvatar:
      "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzl8fHByb2ZpbGV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    userName: "Edward",
  },
  {
    id: "1bf645e9c30beb32ace7fefe",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNeAcbGLYtVaSSR9SaiRBAmxr94SxDIkHKeQ&usqp=CAU",
    userName: "Felicity30",
  },
  {
    id: "b9f74ba3eb9bfc7b0c8fa4ec",
    userAvatar:
      "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDd8fHByb2ZpbGV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    userName: "Kimson_Doan",
  },
  {
    id: "7556d7b07957dccd2dafcefb",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKJOwczlvdonkphUgY7bEVzEBkwR2bNqNpRg&usqp=CAU",
    userName: "Palma.Bogan81",
  },
  {
    id: "fad47822c455acc0e52de",
    userAvatar:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTJ8fHByb2ZpbGV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    userName: "Ayo.Ogunseinde",
  },
  {
    id: "af7fc4dbf74dda2d8bdbab8e",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKYATxhneenZ4tMac0tA38SHffFqFMA5Ql6Q&usqp=CAU",
    userName: "Chance.Purdy47",
  },
  {
    id: "e046e74cb447ec9aa1e2d099",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSgdDf6PlBrImO0rOQ6Cfm0aLxTOZ2w0MBbw&usqp=CAU",
    userName: "Madyson93",
  },
  {
    id: "edcb9d5e6ee31f82b1707bab",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuIqNI4-f9RRe5vielTuDU0w-srV9l9VNsTw&usqp=CAU",
    userName: "Tod11",
  },
  {
    id: "78ae9a44daafefb01db3cf69",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1g3riiGcuaE0z0khYAqNf_O58fmzDKD6SmA&usqp=CAU",
    userName: "Ward.DAmore36",
  },
  {
    id: "8e3e0d10cccdf09c5460796c",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSqD7xJ06XxrDssN7j68ZR963BpSb0K5k8WQ&usqp=CAU",
    userName: "Evans98",
  },
  {
    id: "1fa4ad1b6cdc54f6f7bb4162",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6rONMIDV-I6JrlnyTm2dISo7oGlLgVUYEHQ&usqp=CAU",
    userName: "Justine.Runte",
  },
  {
    id: "b5bd26a0831576e9902b1977",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQEZrATmgHOi5ls0YCCQBTkocia_atSw0X-Q&usqp=CAU",
    userName: "Gilbert57",
  },
  {
    id: "f9b3fcad7fce4adac41bddc3",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmNdSL0wetARyMZVIRgtl2yPZyzXSJQx4EzA&usqp=CAU",
    userName: "Stephany21",
  },
  {
    id: "04ef878b6e8b852effd656a6",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8FuEJbKwDdaz1h387130xmYkAIQbZpahhbQ&usqp=CAU",
    userName: "Rylan.Ortiz3",
  },
  {
    id: "ddd5f9d31f1cac74a26b94ab",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSU1_sf9JEAP0CgU7C9TvEZpBLcPk_1mx97xg&usqp=CAU",
    userName: "Savion_Witting",
  },
  {
    id: "433d6a5baabaa2d1f39d5d5a",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQnVF6kPOwLxFmwHuLQIn-_f6lLFACKWYdCw&usqp=CAU",
    userName: "Lizzie78",
  },

  {
    id: "f26aafdc9a5aa71a7ceff154",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT7Gt93d1h8VKEacR-uu8Y0aGdLupZmMA7fxw&usqp=CAU",
    userName: "Irwin.Kirlin46",
  },
  {
    id: "aa57c811b33c2b14acbd0e99",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6NaS_x_LUygxvqAt5gQ-sR_3ja_1xhSysSw&usqp=CAU",
    userName: "Janiya.Erdman",
  },

  {
    id: "f0fdb8adc928b3b1243b9fac",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSe8ma2KIUHWy3owG081-6NGNCMFbFtH6oI7A&usqp=CAU",
    userName: "Tabitha_Graham55",
  },
];
